import "react";
import { styled as e } from "styled-components";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/Divider/Divider.tsx
var r = e.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(2)};
    padding: ${({ theme: e }) => e.spacing(1.5, 0)};
    user-select: none;
`, i = e.div`
    flex: 1;
    height: 1px;
    background-color: ${({ theme: e }) => e.colors.border};
`, a = e.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    white-space: nowrap;
`, o = ({ text: e, className: o }) => /* @__PURE__ */ n(r, {
	className: o,
	children: [
		/* @__PURE__ */ t(i, {}),
		/* @__PURE__ */ t(a, { children: e }),
		/* @__PURE__ */ t(i, {})
	]
});
//#endregion
export { o as Divider };
